"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _scss = require("@scss");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Pagination = function Pagination(_ref) {
  var pages = _ref.pages,
      pagesDepth = _ref.pagesDepth,
      pageHref = _ref.pageHref,
      firstPageHref = _ref.firstPageHref,
      activePage = _ref.activePage,
      _ref$component = _ref.component,
      Tag = _ref$component === void 0 ? 'a' : _ref$component,
      className = _ref.className,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {
    disabled: '',
    arrow: '',
    item: '',
    wrapper: '',
    previous: '',
    next: '',
    active: '',
    link: ''
  } : _ref$classes;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      pagesArray = _useState2[0],
      setPagesArray = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!pages) {
      setPagesArray([]);
      return;
    }

    var pageItem = pages;
    var thisPageArray = [];
    var minPageDepth = activePage - pagesDepth;
    var maxPageDepth = activePage + pagesDepth;

    if (minPageDepth < 0) {
      minPageDepth = 0;
    }

    while (pageItem) {
      if (pageItem >= minPageDepth && pageItem <= maxPageDepth) {
        thisPageArray.push(pageItem);
      }

      pageItem--;
    }

    setPagesArray(thisPageArray.reverse());
  }, [pages, activePage, pagesDepth]);
  return /*#__PURE__*/_react["default"].createElement("nav", {
    "aria-label": "Navigation"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _scss.cls)(_stylesModule["default"]['pagination'], classes['wrapper'], className)
  }, /*#__PURE__*/_react["default"].createElement("li", {
    className: (0, _scss.cls)(_stylesModule["default"]['page-item'], classes === null || classes === void 0 ? void 0 : classes['item'], activePage === 1 && [_stylesModule["default"]['disabled'], classes['disabled']])
  }, /*#__PURE__*/_react["default"].createElement(Tag, _extends({
    className: (0, _scss.cls)(_stylesModule["default"]['page-link'], classes === null || classes === void 0 ? void 0 : classes['link'], classes === null || classes === void 0 ? void 0 : classes['previous'], classes === null || classes === void 0 ? void 0 : classes['arrow']),
    href: activePage > 1 && pageHref ? activePage === 2 && firstPageHref ? firstPageHref : pageHref.replace('{page}', activePage - 1) : '#',
    "aria-label": "Previous"
  }, activePage === 1 ? {
    tabIndex: -1
  } : undefined), previousLabel ? previousLabel : null, /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true"
  }, "\xAB"), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _scss.cls)('sr-only')
  }, "Previous"))), pagesArray.map(function (p, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: i,
      className: (0, _scss.cls)(_stylesModule["default"]['page-item'], classes === null || classes === void 0 ? void 0 : classes['item'], activePage === p && [_stylesModule["default"]['active'], classes['active']])
    }, /*#__PURE__*/_react["default"].createElement(Tag, {
      className: (0, _scss.cls)(_stylesModule["default"]['page-link'], classes === null || classes === void 0 ? void 0 : classes['link']),
      href: p === 1 && firstPageHref ? firstPageHref : pageHref ? pageHref.replace('{page}', p) : '#'
    }, p, activePage === p ? /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _scss.cls)('sr-only')
    }, "(current)") : null));
  }), /*#__PURE__*/_react["default"].createElement("li", {
    className: (0, _scss.cls)(_stylesModule["default"]['page-item'], classes === null || classes === void 0 ? void 0 : classes['item'], activePage === pages && [_stylesModule["default"]['disabled'], classes['disabled']])
  }, /*#__PURE__*/_react["default"].createElement(Tag, _extends({
    className: (0, _scss.cls)(_stylesModule["default"]['page-link'], _stylesModule["default"]['page-link-next'], classes === null || classes === void 0 ? void 0 : classes['link'], classes === null || classes === void 0 ? void 0 : classes['next'], classes === null || classes === void 0 ? void 0 : classes['arrow']),
    href: activePage < pages && pageHref ? pageHref.replace('{page}', activePage + 1) : '#',
    "aria-label": "Next"
  }, activePage === pages ? {
    tabIndex: -1
  } : undefined), nextLabel ? nextLabel : null, /*#__PURE__*/_react["default"].createElement("span", {
    "aria-hidden": "true"
  }, "\xBB"), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _scss.cls)('sr-only')
  }, "Next")))));
};

var _default = Pagination;
exports["default"] = _default;